module.exports = __webpack_public_path__ + "media/รู้สึกคันที่ไข่.709c1dcf.mp3";